import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { Icon } from 'porosys-ui';
import yup from '../../../common/utils/yup';
import { createComment, updateComment } from '../api';
import '../styles.scss';

const validationSchema = yup.object({
    text: yup.string().required(),
});

const CommentForm = props => {
    const { handleCancelEdit, handleAddComment, handleUpdateComment, mentionedList, commentToEdit, commentParent } =
        props;
    const [shouldEditData, setShouldEditData] = useState(false);

    const history = useHistory();

    const inputValues = {
        text: '',
    };

    useEffect(() => {
        commentToEdit ? setShouldEditData(true) : setShouldEditData(false);
        if (!commentToEdit) {
            setFieldValue('text', '');
            return;
        }
        setFieldValue('text', commentToEdit.text);
    }, [commentToEdit]);

    const { handleSubmit, values, handleChange, setFieldValue } = useFormik({
        initialValues: inputValues,
        onSubmit: values => {
            !shouldEditData
                ? createComment(commentParent[0], commentParent[1], { ...values, mentionedList }).then(res => {
                      handleAddComment(res);
                  })
                : updateComment(commentParent[0], commentParent[1], commentToEdit._id, values).then(res => {
                      handleUpdateComment(res);
                  });

            setFieldValue('text', '');
        },
        validationSchema,
    });

    return (
        <div className="comment-form">
            <form onSubmit={handleSubmit}>
                <textarea
                    className="form-input"
                    value={values.text}
                    label={'متن پیام...'}
                    name="text"
                    placeholder="وارد کنید..."
                    onChange={handleChange('text')}
                />
            </form>
            <div className="form-btn">
                <button onClick={handleSubmit}>
                    <Icon name="plus" />
                </button>
                {commentToEdit && (
                    <button onClick={handleCancelEdit}>
                        <Icon name="arrowCircleLeft" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default CommentForm;
